import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";
import { FieldContext, ValidationResult } from "@angular/forms/signals";
import { AudienceId } from "@front/m19-services";

export function strategyDspAudiencesValidator(): ValidatorFn {
  return (control: AbstractControl<unknown[][]>): ValidationErrors | null => {
    return control.value.length && control.value[0].length > 0 ? null : { emptyAudiences: true };
  };
}

export function validateStrategyDspAudiences(context: FieldContext<AudienceId[][]>): ValidationResult {
  const value = context.value();
  return value.length && value[0].length > 0 ? null : { kind: "emptyAudiences" };
}
